var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex1" },
    [
      _c("div", { staticClass: "userContext" }, [
        _c(
          "div",
          { staticClass: "col6-left col6-mdBreak flex1 textAlignRight" },
          [
            _c("p", { staticClass: "marginB0" }, [
              _vm._v("Viewing as: "),
              _c("b", [
                _vm._v(
                  _vm._s(_vm._.get(_vm.userCurrentContext, "label", "Unknown"))
                )
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col6-right col6-mdBreak flex1 textAlignLeft" },
          [
            _c(
              "b-button",
              {
                staticClass: "largeBtn marginB0",
                attrs: { type: "button", variant: "primary" },
                on: { click: _vm.toggleModal }
              },
              [_vm._v("Change Organization")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            size: "lg",
            centered: "",
            title: "Change Group/Organization",
            "header-bg-variant": "success",
            "header-text-variant": "light",
            visible: _vm.showModal,
            "ok-title": "Save"
          },
          on: { hide: _vm.toggleModal, ok: _vm.umogChangeHandler },
          scopedSlots: _vm._u([
            {
              key: "modal-header-close",
              fn: function() {
                return [_c("h4", [_vm._v("X")])]
              },
              proxy: true
            }
          ])
        },
        [
          _vm._v(" "),
          _c(
            "b-form",
            [
              _c(
                "b-form-group",
                [
                  _c(
                    "b-form-select",
                    {
                      attrs: {
                        options: _vm.userGroupOrganizationOptions,
                        placeholder: "Type to Search"
                      },
                      model: {
                        value: _vm.userGroupOrganization,
                        callback: function($$v) {
                          _vm.userGroupOrganization = $$v
                        },
                        expression: "userGroupOrganization"
                      }
                    },
                    [
                      _c("template", { slot: "first" }, [
                        _c(
                          "option",
                          {
                            attrs: { disabled: "" },
                            domProps: { value: null }
                          },
                          [_vm._v("-- Please select a group --")]
                        )
                      ])
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-178f63f2", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-178f63f2","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header/UserContext.vue
// module id = 1419
// module chunks = 0